(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dmc-return-form"]) return;
  try {
    

function dmc_register_products_multiplier() {

  var trigger = $('.multiplier-trigger');

  trigger.click( function() {
    var wrapper = $('.dmc-product-return-wrapper');
    var hidden_fields = wrapper.find('.dmc-product-return:not(:visible)');

    if ( hidden_fields.length !== 1 ) {
      hidden_fields.eq(0).fadeIn();
    } else {
      hidden_fields.eq(0).fadeIn();
      trigger.fadeOut();
    }
  });

}
dmc_register_products_multiplier();

function dmc_register_return_form_submit() {
	var form = $('.dmc-return-form form');
	var submit = form.find('.dmc-return-form-submit-button');
	form.on( 'submit', function( e ) {
		if ( ! form.hasClass('dmc-processed') ) {
			e.preventDefault();
			var hidden_fields = form.find('.dmc-product-return-wrapper .dmc-form-field-group:not(:visible)');
			hidden_fields.remove();
			form.addClass('dmc-processed');
            setTimeout( function() {
				submit.click();
            }, 100 );
		}
	});
}
dmc_register_return_form_submit();

function dmc_register_return_form_selectors() {
<!-- 	console.log('version 18'); -->
	var products_data = $('#dmc-products-data');
	var return_groups = $('.dmc-form-field-group.dmc-product-return');
	return_groups.each( function() {
		var return_group = $(this);
		var product_selector = return_group.find('.dmc-form-field-selector-product select');
		var variant_selector = return_group.find('.dmc-form-field-selector-variant select');
		var sku_input = return_group.find('.dmc-sku-input');
		product_selector.on('change', function() {
			var val = product_selector.val();
			variant_selector.html('<option value=""></option>');
			sku_input.val('');
			if ( val !== '' ) {
				var t_product_data = products_data.find(".data-product[data-title='" + val + "']");
				var t_product_variants = t_product_data.find('.data-variant');
				if ( t_product_variants.length === 1 && t_product_variants.data('title') === 'Default Title' ) {
					variant_selector.attr('disabled', 'disabled');
					sku_input.val( t_product_variants.data('sku') );
				} else {
					variant_selector.removeAttr('disabled');
				}

				t_product_variants.each( function() {
					var t_variant = $( this );
					variant_selector.append('<option value="' + t_variant.data('title') + '">' + t_variant.data('title') + '</option>');
				});
			}
		});
        variant_selector.on('change', function() {
        	var val = variant_selector.val();
          	sku_input.val('');
        	if ( val !== '' ) {
        		var t_product_data = products_data.find(".data-product[data-title='" + product_selector.val() + "']");
        		var t_product_variant = t_product_data.find(".data-variant[data-title='" + val + "']");
				var t_product_variant_sku = t_product_variant.data('sku');
       			sku_input.val( t_product_variant_sku );
        	}
        });
	});

}
dmc_register_return_form_selectors();


  } catch(e) { console.error(e); }
})();
})();
